import React, { Component } from 'react'
import AccountSetup from "./AccountSetup/AccountSetup"
import SocialProfiles from "./SocialProfiles/SocialProfiles"
import Confirm from "./Confirm/Confirm"
import Success from "./Success/Success"

class Form extends Component {
  state = {
    step: 1,
    name: "",
    email: "",
    phone: "",
    bio: "",
    facebook: "",
    twitter: "",
    youtube: "",
    instagram: "",
    linkedin: "",
    github: ""


  }


  //proceed to next step
  nextStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1
    })
  }

  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1
    });
  }

  //handle fields change

  inputChange = input => e => {
    this.setState({ [input]: e.target.value })
  }


  render() {

    const { step } = this.state;
    const { name, email, phone, bio, facebook, twitter, youtube, instagram, linkedin, github } = this.state;
    const values = { name, email, phone, bio, facebook, twitter, youtube, instagram, linkedin, github };

    switch (step) {
      case 1:
        return (
          <AccountSetup
            nextStep={this.nextStep}
            inputChange={this.inputChange}
            values={values}
          />
        )
      case 2:
        return (
          <SocialProfiles
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            inputChange={this.inputChange}
            values={values}
          />
        )
      case 3:
        return (
          <Confirm
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            inputChange={this.inputChange}
            values={values}
          />

        )
      case 4:
        return (
          <Success />
        )
      default: //do nothing

    }


  }



}
export default Form